import { ComponentState, ResourceHandle, Subtask, CallContext, EventLoop, suspending, promising, setJspiMode } from '@jellevdh/wcjs/runtime';

const __base = new URL('.', import.meta.url);
async function __loadCoreModule(name) {
  const url = new URL(name, __base);
  if (typeof globalThis.process !== 'undefined') {
    const { readFile } = await import('node:fs/promises');
    return new WebAssembly.Module(await readFile(url));
  }
  return WebAssembly.compileStreaming(fetch(url));
}

export async function instantiate(imports, instantiateCore = WebAssembly.instantiate) {
    const _eventLoop = new EventLoop();
    setJspiMode(true);
    const state0 = new ComponentState(0);
    state0.setEventLoop(_eventLoop);
    _eventLoop.registerComponentState(state0);
    
    const _hostIface0 = imports['wasi:cli/stderr@0.2.6'];
    const _hostIface1 = imports['wasi:cli/stdin@0.2.6'];
    const _hostIface2 = imports['wasi:cli/stdout@0.2.6'];
    const _hostIface3 = imports['wasi:cli/exit@0.2.6'];
    const _hostIface4 = imports['demo:calculator/host'];
    const _hostIface5 = imports['wasi:io/streams@0.2.6'];
    const _hostIface6 = imports['wasi:filesystem/types@0.2.6'];
    const _hostIface7 = imports['wasi:filesystem/preopens@0.2.6'];
    const _hostIface8 = imports['wasi:cli/environment@0.2.6'];
    const _hostIface9 = imports['wasi:io/error@0.2.6'];
    
    let memory0;
    
    let callback_0;
    
    const trampoline0 = (value) => {
        state0.currentTask.resolve(value);
    };
    const trampoline1 = suspending((subtaskIdx) => { state0.checkSyncBlock(); return state0.subtaskCancel(subtaskIdx, false); });
    const trampoline2 = () => state0.contextGet(0);
    const trampoline3 = (val) => state0.contextSet(0, val);
    const trampoline4 = (waitableIdx, wsIdx) => state0.waitableJoin(waitableIdx, wsIdx);
    const trampoline5 = () => state0.waitableSetNew();
    const trampoline6 = (wsIdx) => state0.waitableSetDrop(wsIdx);
    const trampoline7 = (subtaskIdx) => state0.subtaskDrop(subtaskIdx);
    const trampoline8 = () => state0.taskCancel();
    const trampoline9 = (handle) => { state0.resourceDrop(0, handle, (rep) => _hostIface5['[resource-drop]output-stream'](rep)); };
    const trampoline10 = (handle) => { state0.resourceDrop(1, handle, (rep) => _hostIface5['[resource-drop]input-stream'](rep)); };
    const trampoline11 = (handle) => { state0.resourceDrop(2, handle, (rep) => _hostIface6['[resource-drop]descriptor'](rep)); };
    const trampoline12 = (handle) => { state0.resourceDrop(3, handle, (rep) => _hostIface9['[resource-drop]error'](rep)); };
    const trampoline13 = () => {
        const hostFn = _hostIface0['get-stderr'];
        return state0.resourceNew(4, hostFn());
    };
    const trampoline14 = () => {
        const hostFn = _hostIface1['get-stdin'];
        return state0.resourceNew(1, hostFn());
    };
    const trampoline15 = () => {
        const hostFn = _hostIface2['get-stdout'];
        return state0.resourceNew(4, hostFn());
    };
    const trampoline16 = (p0) => {
        const hostFn = _hostIface3['exit'];
        const arg0 = (p0 === 0 ? { tag: 'ok' } : { tag: 'err' });
        hostFn(arg0);
    };
    const trampoline17 = (wsIdx, ptr) => {
        return state0.waitableSetPoll(memory0, wsIdx, ptr);
    };
    const trampoline18 = (p0_0, p0_1) => {
        const hostFn = _hostIface4['log'];
        const arg0 = new TextDecoder().decode(new Uint8Array(memory0.buffer, p0_0, p0_1));
        hostFn(arg0);
    };
    const trampoline19 = (p0, retptr) => {
        const hostFn = _hostIface4['slow-double'];
        const result = hostFn(p0);
        const _store = (_r) => {
        new DataView(memory0.buffer).setInt32(retptr + 0, _r, true);
        };
        if (result instanceof Promise) {
            return state0.lowerImportAsync((result).then(_store));
        }
        _store(result);
        return state0.lowerImportAsync(undefined);
    };
    const trampoline20 = (p0, p1_0, p1_1, retptr) => {
        const hostFn = _hostIface5['[method]output-stream.blocking-write-and-flush'];
        const arg0 = state0.getResourceHandle(p0).rep;
        const arg1 = new Uint8Array(memory0.buffer.slice(p1_0, (p1_0) + (p1_1)));
        const result = hostFn(arg0, arg1);
        const _rv0 = result;
        if (_rv0.tag === 'ok') {
          new DataView(memory0.buffer).setUint8(retptr + 0, 0);
        } else {
          new DataView(memory0.buffer).setUint8(retptr + 0, 1);
        const _vo1 = _rv0.val;
        if (_vo1.tag === 'last-operation-failed') {
          new DataView(memory0.buffer).setUint8(retptr + 4, 0);
        new DataView(memory0.buffer).setInt32(retptr + 8, state0.resourceNew(3, _vo1.val), true);
        }
        else if (_vo1.tag === 'closed') {
          new DataView(memory0.buffer).setUint8(retptr + 4, 1);
        }
        }
    };
    const trampoline21 = (p0, retptr) => {
        const hostFn = _hostIface6['filesystem-error-code'];
        const arg0 = state0.getResourceHandle(p0).rep;
        const result = hostFn(arg0);
        if (result == null) {
          new DataView(memory0.buffer).setUint8(retptr + 0, 0);
        } else {
          new DataView(memory0.buffer).setUint8(retptr + 0, 1);
        const _em0 = {'access':0,'would-block':1,'already':2,'bad-descriptor':3,'busy':4,'deadlock':5,'quota':6,'exist':7,'file-too-large':8,'illegal-byte-sequence':9,'in-progress':10,'interrupted':11,'invalid':12,'io':13,'is-directory':14,'loop':15,'too-many-links':16,'message-size':17,'name-too-long':18,'no-device':19,'no-entry':20,'no-lock':21,'insufficient-memory':22,'insufficient-space':23,'not-directory':24,'not-empty':25,'not-recoverable':26,'unsupported':27,'no-tty':28,'no-such-device':29,'overflow':30,'not-permitted':31,'pipe':32,'read-only':33,'invalid-seek':34,'text-file-busy':35,'cross-device':36};
        new DataView(memory0.buffer).setUint8(retptr + 1, _em0[result]);
        }
    };
    const trampoline22 = (p0, p1, retptr) => {
        const hostFn = _hostIface6['[method]descriptor.write-via-stream'];
        const arg0 = state0.getResourceHandle(p0).rep;
        const result = hostFn(arg0, p1);
        const _rv0 = result;
        if (_rv0.tag === 'ok') {
          new DataView(memory0.buffer).setUint8(retptr + 0, 0);
        new DataView(memory0.buffer).setInt32(retptr + 4, state0.resourceNew(4, _rv0.val), true);
        } else {
          new DataView(memory0.buffer).setUint8(retptr + 0, 1);
        const _em1 = {'access':0,'would-block':1,'already':2,'bad-descriptor':3,'busy':4,'deadlock':5,'quota':6,'exist':7,'file-too-large':8,'illegal-byte-sequence':9,'in-progress':10,'interrupted':11,'invalid':12,'io':13,'is-directory':14,'loop':15,'too-many-links':16,'message-size':17,'name-too-long':18,'no-device':19,'no-entry':20,'no-lock':21,'insufficient-memory':22,'insufficient-space':23,'not-directory':24,'not-empty':25,'not-recoverable':26,'unsupported':27,'no-tty':28,'no-such-device':29,'overflow':30,'not-permitted':31,'pipe':32,'read-only':33,'invalid-seek':34,'text-file-busy':35,'cross-device':36};
        new DataView(memory0.buffer).setUint8(retptr + 4, _em1[_rv0.val]);
        }
    };
    const trampoline23 = (p0, retptr) => {
        const hostFn = _hostIface6['[method]descriptor.append-via-stream'];
        const arg0 = state0.getResourceHandle(p0).rep;
        const result = hostFn(arg0);
        const _rv0 = result;
        if (_rv0.tag === 'ok') {
          new DataView(memory0.buffer).setUint8(retptr + 0, 0);
        new DataView(memory0.buffer).setInt32(retptr + 4, state0.resourceNew(4, _rv0.val), true);
        } else {
          new DataView(memory0.buffer).setUint8(retptr + 0, 1);
        const _em1 = {'access':0,'would-block':1,'already':2,'bad-descriptor':3,'busy':4,'deadlock':5,'quota':6,'exist':7,'file-too-large':8,'illegal-byte-sequence':9,'in-progress':10,'interrupted':11,'invalid':12,'io':13,'is-directory':14,'loop':15,'too-many-links':16,'message-size':17,'name-too-long':18,'no-device':19,'no-entry':20,'no-lock':21,'insufficient-memory':22,'insufficient-space':23,'not-directory':24,'not-empty':25,'not-recoverable':26,'unsupported':27,'no-tty':28,'no-such-device':29,'overflow':30,'not-permitted':31,'pipe':32,'read-only':33,'invalid-seek':34,'text-file-busy':35,'cross-device':36};
        new DataView(memory0.buffer).setUint8(retptr + 4, _em1[_rv0.val]);
        }
    };
    const trampoline24 = (p0, retptr) => {
        const hostFn = _hostIface6['[method]descriptor.stat'];
        const arg0 = state0.getResourceHandle(p0).rep;
        const result = hostFn(arg0);
        const _rv0 = result;
        if (_rv0.tag === 'ok') {
          new DataView(memory0.buffer).setUint8(retptr + 0, 0);
        const _em1 = {'unknown':0,'block-device':1,'character-device':2,'directory':3,'fifo':4,'symbolic-link':5,'regular-file':6,'socket':7};
        new DataView(memory0.buffer).setUint8(retptr + 8, _em1[_rv0.val['type']]);
        new DataView(memory0.buffer).setBigInt64(retptr + 16, _rv0.val['link-count'], true);
        new DataView(memory0.buffer).setBigInt64(retptr + 24, _rv0.val['size'], true);
        if (_rv0.val['data-access-timestamp'] == null) {
          new DataView(memory0.buffer).setUint8(retptr + 32, 0);
        } else {
          new DataView(memory0.buffer).setUint8(retptr + 32, 1);
        new DataView(memory0.buffer).setBigInt64(retptr + 40, _rv0.val['data-access-timestamp']['seconds'], true);
        new DataView(memory0.buffer).setInt32(retptr + 48, _rv0.val['data-access-timestamp']['nanoseconds'], true);
        }
        if (_rv0.val['data-modification-timestamp'] == null) {
          new DataView(memory0.buffer).setUint8(retptr + 56, 0);
        } else {
          new DataView(memory0.buffer).setUint8(retptr + 56, 1);
        new DataView(memory0.buffer).setBigInt64(retptr + 64, _rv0.val['data-modification-timestamp']['seconds'], true);
        new DataView(memory0.buffer).setInt32(retptr + 72, _rv0.val['data-modification-timestamp']['nanoseconds'], true);
        }
        if (_rv0.val['status-change-timestamp'] == null) {
          new DataView(memory0.buffer).setUint8(retptr + 80, 0);
        } else {
          new DataView(memory0.buffer).setUint8(retptr + 80, 1);
        new DataView(memory0.buffer).setBigInt64(retptr + 88, _rv0.val['status-change-timestamp']['seconds'], true);
        new DataView(memory0.buffer).setInt32(retptr + 96, _rv0.val['status-change-timestamp']['nanoseconds'], true);
        }
        } else {
          new DataView(memory0.buffer).setUint8(retptr + 0, 1);
        const _em2 = {'access':0,'would-block':1,'already':2,'bad-descriptor':3,'busy':4,'deadlock':5,'quota':6,'exist':7,'file-too-large':8,'illegal-byte-sequence':9,'in-progress':10,'interrupted':11,'invalid':12,'io':13,'is-directory':14,'loop':15,'too-many-links':16,'message-size':17,'name-too-long':18,'no-device':19,'no-entry':20,'no-lock':21,'insufficient-memory':22,'insufficient-space':23,'not-directory':24,'not-empty':25,'not-recoverable':26,'unsupported':27,'no-tty':28,'no-such-device':29,'overflow':30,'not-permitted':31,'pipe':32,'read-only':33,'invalid-seek':34,'text-file-busy':35,'cross-device':36};
        new DataView(memory0.buffer).setUint8(retptr + 8, _em2[_rv0.val]);
        }
    };
    const trampoline25 = (p0, retptr) => {
        const hostFn = _hostIface6['[method]descriptor.get-type'];
        const arg0 = state0.getResourceHandle(p0).rep;
        const result = hostFn(arg0);
        const _rv0 = result;
        if (_rv0.tag === 'ok') {
          new DataView(memory0.buffer).setUint8(retptr + 0, 0);
        const _em1 = {'unknown':0,'block-device':1,'character-device':2,'directory':3,'fifo':4,'symbolic-link':5,'regular-file':6,'socket':7};
        new DataView(memory0.buffer).setUint8(retptr + 1, _em1[_rv0.val]);
        } else {
          new DataView(memory0.buffer).setUint8(retptr + 0, 1);
        const _em2 = {'access':0,'would-block':1,'already':2,'bad-descriptor':3,'busy':4,'deadlock':5,'quota':6,'exist':7,'file-too-large':8,'illegal-byte-sequence':9,'in-progress':10,'interrupted':11,'invalid':12,'io':13,'is-directory':14,'loop':15,'too-many-links':16,'message-size':17,'name-too-long':18,'no-device':19,'no-entry':20,'no-lock':21,'insufficient-memory':22,'insufficient-space':23,'not-directory':24,'not-empty':25,'not-recoverable':26,'unsupported':27,'no-tty':28,'no-such-device':29,'overflow':30,'not-permitted':31,'pipe':32,'read-only':33,'invalid-seek':34,'text-file-busy':35,'cross-device':36};
        new DataView(memory0.buffer).setUint8(retptr + 1, _em2[_rv0.val]);
        }
    };
    const trampoline26 = (retptr) => {
        const hostFn = _hostIface7['get-directories'];
        const result = hostFn();
        const _gl0 = result;
        const _gb0 = (instance2.exports['cabi_import_realloc'])(0, 0, 4, _gl0.length * 12);
        for (let _i0 = 0; _i0 < _gl0.length; _i0++) {
        new DataView(memory0.buffer).setInt32(_gb0 + _i0 * 12 + 0, state0.resourceNew(2, _gl0[_i0][0]), true);
        const _enc1 = new TextEncoder().encode(_gl0[_i0][1]);
        const _ptr1 = (instance2.exports['cabi_import_realloc'])(0, 0, 1, _enc1.length);
        new Uint8Array(memory0.buffer, _ptr1, _enc1.length).set(_enc1);
        new DataView(memory0.buffer).setInt32(_gb0 + _i0 * 12 + 4, _ptr1, true);
        new DataView(memory0.buffer).setInt32(_gb0 + _i0 * 12 + 8, _enc1.length, true);
        }
        new DataView(memory0.buffer).setInt32(retptr + 0, _gb0, true);
        new DataView(memory0.buffer).setInt32(retptr + 4, _gl0.length, true);
    };
    const trampoline27 = (retptr) => {
        const hostFn = _hostIface8['get-environment'];
        const result = hostFn();
        const _gl0 = result;
        const _gb0 = (instance2.exports['cabi_import_realloc'])(0, 0, 4, _gl0.length * 16);
        for (let _i0 = 0; _i0 < _gl0.length; _i0++) {
        const _enc1 = new TextEncoder().encode(_gl0[_i0][0]);
        const _ptr1 = (instance2.exports['cabi_import_realloc'])(0, 0, 1, _enc1.length);
        new Uint8Array(memory0.buffer, _ptr1, _enc1.length).set(_enc1);
        new DataView(memory0.buffer).setInt32(_gb0 + _i0 * 16 + 0, _ptr1, true);
        new DataView(memory0.buffer).setInt32(_gb0 + _i0 * 16 + 4, _enc1.length, true);
        const _enc2 = new TextEncoder().encode(_gl0[_i0][1]);
        const _ptr2 = (instance2.exports['cabi_import_realloc'])(0, 0, 1, _enc2.length);
        new Uint8Array(memory0.buffer, _ptr2, _enc2.length).set(_enc2);
        new DataView(memory0.buffer).setInt32(_gb0 + _i0 * 16 + 8, _ptr2, true);
        new DataView(memory0.buffer).setInt32(_gb0 + _i0 * 16 + 12, _enc2.length, true);
        }
        new DataView(memory0.buffer).setInt32(retptr + 0, _gb0, true);
        new DataView(memory0.buffer).setInt32(retptr + 4, _gl0.length, true);
    };
    const trampoline28 = (p0, retptr) => {
        const hostFn = _hostIface5['[method]output-stream.check-write'];
        const arg0 = state0.getResourceHandle(p0).rep;
        const result = hostFn(arg0);
        const _rv0 = result;
        if (_rv0.tag === 'ok') {
          new DataView(memory0.buffer).setUint8(retptr + 0, 0);
        new DataView(memory0.buffer).setBigInt64(retptr + 8, _rv0.val, true);
        } else {
          new DataView(memory0.buffer).setUint8(retptr + 0, 1);
        const _vo1 = _rv0.val;
        if (_vo1.tag === 'last-operation-failed') {
          new DataView(memory0.buffer).setUint8(retptr + 8, 0);
        new DataView(memory0.buffer).setInt32(retptr + 12, state0.resourceNew(3, _vo1.val), true);
        }
        else if (_vo1.tag === 'closed') {
          new DataView(memory0.buffer).setUint8(retptr + 8, 1);
        }
        }
    };
    const trampoline29 = (p0, p1_0, p1_1, retptr) => {
        const hostFn = _hostIface5['[method]output-stream.write'];
        const arg0 = state0.getResourceHandle(p0).rep;
        const arg1 = new Uint8Array(memory0.buffer.slice(p1_0, (p1_0) + (p1_1)));
        const result = hostFn(arg0, arg1);
        const _rv0 = result;
        if (_rv0.tag === 'ok') {
          new DataView(memory0.buffer).setUint8(retptr + 0, 0);
        } else {
          new DataView(memory0.buffer).setUint8(retptr + 0, 1);
        const _vo1 = _rv0.val;
        if (_vo1.tag === 'last-operation-failed') {
          new DataView(memory0.buffer).setUint8(retptr + 4, 0);
        new DataView(memory0.buffer).setInt32(retptr + 8, state0.resourceNew(3, _vo1.val), true);
        }
        else if (_vo1.tag === 'closed') {
          new DataView(memory0.buffer).setUint8(retptr + 4, 1);
        }
        }
    };
    const trampoline30 = (p0, retptr) => {
        const hostFn = _hostIface5['[method]output-stream.blocking-flush'];
        const arg0 = state0.getResourceHandle(p0).rep;
        const result = hostFn(arg0);
        const _rv0 = result;
        if (_rv0.tag === 'ok') {
          new DataView(memory0.buffer).setUint8(retptr + 0, 0);
        } else {
          new DataView(memory0.buffer).setUint8(retptr + 0, 1);
        const _vo1 = _rv0.val;
        if (_vo1.tag === 'last-operation-failed') {
          new DataView(memory0.buffer).setUint8(retptr + 4, 0);
        new DataView(memory0.buffer).setInt32(retptr + 8, state0.resourceNew(3, _vo1.val), true);
        }
        else if (_vo1.tag === 'closed') {
          new DataView(memory0.buffer).setUint8(retptr + 4, 1);
        }
        }
    };
    
    const module0 = await __loadCoreModule('calculator.core.wasm');
    const module1 = await __loadCoreModule('calculator.core2.wasm');
    const module2 = await __loadCoreModule('calculator.core3.wasm');
    const module3 = await __loadCoreModule('calculator.core4.wasm');
    let instance0;
    let instance1;
    let instance2;
    let instance3;
    
    instance0 = await instantiateCore(module2, {
    });
    instance1 = await instantiateCore(module0, {
        '$root': {
            '[context-get-0]': trampoline2,
            '[context-set-0]': trampoline3,
            '[subtask-cancel]': trampoline1,
            '[subtask-drop]': trampoline7,
            '[waitable-join]': trampoline4,
            '[waitable-set-drop]': trampoline6,
            '[waitable-set-new]': trampoline5,
            '[waitable-set-poll]': instance0.exports['2'],
        },
        '[export]$root': {
            '[task-cancel]': trampoline8,
        },
        '[export]demo:calculator/calc': {
            '[task-return]double-and-add': trampoline0,
        },
        'demo:calculator/host': {
            '[async-lower]slow-double': instance0.exports['1'],
            'log': instance0.exports['0'],
        },
        'wasi_snapshot_preview1': {
            'environ_get': instance0.exports['3'],
            'environ_sizes_get': instance0.exports['4'],
            'fd_write': instance0.exports['5'],
            'proc_exit': instance0.exports['6'],
        },
    });
    instance2 = await instantiateCore(module1, {
        '__main_module__': {
            'cabi_realloc': instance1.exports['cabi_realloc'],
        },
        'env': {
            'memory': instance1.exports['memory'],
        },
        'wasi:cli/environment@0.2.6': {
            'get-environment': instance0.exports['17'],
        },
        'wasi:cli/exit@0.2.6': {
            'exit': trampoline16,
        },
        'wasi:cli/stderr@0.2.6': {
            'get-stderr': trampoline13,
        },
        'wasi:cli/stdin@0.2.6': {
            'get-stdin': trampoline14,
        },
        'wasi:cli/stdout@0.2.6': {
            'get-stdout': trampoline15,
        },
        'wasi:filesystem/preopens@0.2.6': {
            'get-directories': instance0.exports['16'],
        },
        'wasi:filesystem/types@0.2.6': {
            '[method]descriptor.append-via-stream': instance0.exports['13'],
            '[method]descriptor.get-type': instance0.exports['15'],
            '[method]descriptor.stat': instance0.exports['14'],
            '[method]descriptor.write-via-stream': instance0.exports['12'],
            '[resource-drop]descriptor': trampoline11,
            'filesystem-error-code': instance0.exports['11'],
        },
        'wasi:io/error@0.2.6': {
            '[resource-drop]error': trampoline12,
        },
        'wasi:io/streams@0.2.6': {
            '[method]output-stream.blocking-flush': instance0.exports['9'],
            '[method]output-stream.blocking-write-and-flush': instance0.exports['10'],
            '[method]output-stream.check-write': instance0.exports['7'],
            '[method]output-stream.write': instance0.exports['8'],
            '[resource-drop]input-stream': trampoline10,
            '[resource-drop]output-stream': trampoline9,
        },
    });
    instance3 = await instantiateCore(module3, {
        '': {
            '$imports': instance0.exports['$imports'],
            '0': trampoline18,
            '1': trampoline19,
            '10': trampoline20,
            '11': trampoline21,
            '12': trampoline22,
            '13': trampoline23,
            '14': trampoline24,
            '15': trampoline25,
            '16': trampoline26,
            '17': trampoline27,
            '2': trampoline17,
            '3': instance2.exports['environ_get'],
            '4': instance2.exports['environ_sizes_get'],
            '5': instance2.exports['fd_write'],
            '6': instance2.exports['proc_exit'],
            '7': trampoline28,
            '8': trampoline29,
            '9': trampoline30,
        },
    });
    
    memory0 = instance1.exports['memory'];
    callback_0 = instance1.exports['[callback][async-lift]demo:calculator/calc#double-and-add'];
    
    const add = (...args) => state0.runSyncExport(instance1.exports['demo:calculator/calc#add'], args);
    const doubleAndAdd = (...args) => state0.runAsyncExport(instance1.exports['[async-lift]demo:calculator/calc#double-and-add'], callback_0, _eventLoop, args);
    
    return {
        'demo:calculator/calc': { add, doubleAndAdd },
        '$states': [state0],
        '$destroy': () => { state0.destroy() },
    };
}
